import { createNode } from '@glueapp/graph-types';

export const Ceil = createNode({
    id: 'Ceil',
    name: 'Ceil',
    description: 'Rounds the number up to the next highest full number. Examples: 0.3 becomes 1, -2,2 becomes -2 and 3.8 becomes 4',
    aiDescription:
        'Rounds a number up to the nearest integer (ceiling). Connect a value to the "Number" input port; the "Next Highest Number" output port provides the result.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Number: { kind: 'number' },
    },
    outPorts: {
        'Next Highest Number': { kind: 'number' },
    },
    execute: function (input) {
        const inputNumber = input.inPorts.Number;
        return { output: { 'Next Highest Number': Math.ceil(inputNumber) } };
    },
});
